import C from './component'
import p from './props'

export { C, p }
